import React, { Component } from "react";
import NumberFormat from "react-number-format";

// Components
import ErrorWrap from "./error-success/ErrorWrap";

// CSS
import "../../css/forms/phone-field.css";

class PhoneField extends Component {
	render() {
		const {
			label,
			phone,
			extension,
			phone_name,
			ext_name,
			errorPhone,
			errorExtension,
			translations
		} = this.props;

		const inProcess = this.props.inProcess ? this.props.inProccess : false;

		return (
			<div className="phone-field-wrapper half-field">
				{!!label && <label htmlFor="phone">{label}:</label>}
				{errorPhone && <ErrorWrap animate={1}>{errorPhone}</ErrorWrap>}
				{errorExtension && <ErrorWrap animate={1}>{errorExtension}</ErrorWrap>}

				<div className="phone-inputs">
					<div className="phone-field phone-field--main">
						<NumberFormat
							id={phone_name}
							placeholder="555 555 5555"
							value={phone}
							type="tel"
							format="### ### ####"
							mask="_"
							disabled={inProcess}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onValueChange={values =>
								this.props.handleInputChange({
									target: { id: phone_name, value: values.value }
								})
							}
						/>
					</div>

					<div className="phone-field phone-field--extension">
						<label htmlFor="phone_extension">
							{!!translations ? translations.sections.form_elements.extension : "Ext"}
							:
						</label>
						<NumberFormat
							id={ext_name}
							placeholder="1234"
							value={extension}
							type="tel"
							format="#####"
							mask="_"
							disabled={inProcess}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onValueChange={values =>
								this.props.handleInputChange({
									target: { id: ext_name, value: values.value }
								})
							}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default PhoneField;



// WEBPACK FOOTER //
// ./src/components/utils/PhoneField.js